import { PageFooter } from "../../common/components/page-container/components/PageFooter/PageFooter";
import { usePageTitle } from "../../common/hooks";
import { Hero } from "./components/hero/Hero";
import { TopGamesSection } from "./components/TopGamesSection";
import { PageHeader } from "../../common/components/page-container/components/PageHeader/PageHeader";
import React from "react";
import { PageContent } from "../../common/components/page-container/components/PageContent/PageContent";
import reviews from "./reviews.json";
import ReviewsCarousel from "./components/reviews-carousel/ReviewsCarousel";
import ForWhomSection from "./components/for-whom/ForWhomSection";
import WhyYouShouldTrySection from "./components/why-you-should-try/WhyYouShouldTrySection";
import Faq from "./components/faq/Faq";

const HomePage = () => {
  usePageTitle("title.home");

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <PageHeader />
      <Hero />
      <PageContent>
        <ForWhomSection />
        <WhyYouShouldTrySection/>
        <TopGamesSection />
        <Faq/>
        <ReviewsCarousel reviews={reviews} />
      </PageContent>
      <PageFooter />
    </div>
  );
};
export default HomePage;
